<template>
  <section class="onboarding-modal__step">
    <div class="onboarding-modal__step-badge">{{ stepBadgeLabel }}</div>
    <div class="onboarding-modal__step-header">
      <div class="onboarding-modal__step-title">Add your Birthday</div>
      <div class="onboarding-modal__step-info">
        Want special offers on your special day? Add your birthday and be on the
        lookout for a gift from us!
      </div>
    </div>
    <div class="birthday-calendar__wrapper">
      <MonthCalendar
        @calendar-current-date="setCurrentDate"
        :birthdate="currentDate"
      />
    </div>
    <div class="onboarding-modal__step-btn-wrapper">
      <button
        type="submit"
        class="btn btn--primary onboarding-modal__step-save-btn"
        :disabled="isSaveDisabled"
        @click="saveBirthday()"
      >
        Save Birthday
      </button>
      <button
        @click="$emit('close-onboarding-modal')"
        class="btn btn--secondary onboarding-modal__step-next-btn"
      >
        Close
      </button>
      <button
        @click="$emit('go-previus-step')"
        class="btn btn--tertiary onboarding-modal__step-back-btn"
      >
        Back
      </button>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import MonthCalendar from '@/components/shared/MonthCalendar.vue'

export default {
  name: 'Birthday',
  components: {
    MonthCalendar,
  },
  props: {
    stepBadgeLabel: {
      type: String,
      required: true,
    },
    onboardingSurvey: {
      type: Object,
      required: true,
    },
    userProfile: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isSaveDisabled: true,
      currentDate: {
        birth_month: 1,
        birth_day: 1,
      },
    }
  },
  computed: {
    ...mapState({
      profileOnboarding: state => state.auth.profileOnboarding,
    }),
  },
  watch: {
    currentDate() {
      const { birth_month, birth_day } = this.userProfile?.user_current_profile
      if (
        birth_month !== this.currentDate.birth_month ||
        birth_day !== this.currentDate.birth_day
      ) {
        this.isSaveDisabled = false
      }
    },
  },
  methods: {
    setCurrentDate(currentDate) {
      this.currentDate = currentDate
    },
    async saveBirthday() {
      if (!this.currentDate) return
      this.isSaveDisabled = true
      this.$emit('set-loader', true)
      try {
        await this.$store.dispatch('auth/updateBirthday', this.currentDate)
        if (!this.onboardingSurvey?.data?.birthday) {
          const onboardingSurvey = {
            ...this.onboardingSurvey.data,
            birthday: true,
          }
          await this.$store.dispatch(
            'auth/setOnboardingSurvey',
            onboardingSurvey
          )
        }
        this.isSaveDisabled = true
      } finally {
        this.$emit('set-loader', false)
      }
    },
  },
  created() {
    const userCurrentProfile = this.userProfile?.user_current_profile
    this.setCurrentDate({
      birth_month: userCurrentProfile?.birth_month || 1,
      birth_day: userCurrentProfile?.birth_day || 1,
    })
  },
}
</script>
